const baseUrl = "https://pench-be-prod-service-468241318411.asia-south1.run.app/";
// const baseUrl = "https://datarepositorytatr.in/";
// const baseUrl = "http://localhost:8000/";

export { baseUrl };
